var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSuccessStatus = function SvgSuccessStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#06CF7F",
    d: "M12.354 20.292a1 1 0 011.676 1.09A24.875 24.875 0 0010 35c0 13.807 11.193 25 25 25s25-11.193 25-25-11.193-25-25-25a24.88 24.88 0 00-12.162 3.152 1 1 0 01-.975-1.746A26.88 26.88 0 0135 8c14.912 0 27 12.088 27 27S49.912 62 35 62 8 49.912 8 35a26.875 26.875 0 014.354-14.708zM17 17a1 1 0 110-2 1 1 0 010 2zm9.559 19.54l6.377 4.353 10.23-15.166a1 1 0 111.658 1.118L33.47 43.678l-8.039-5.485a1 1 0 011.128-1.652z"
  })));
};
export default SvgSuccessStatus;